import { render, staticRenderFns } from "./ModalInfoVehicle.vue?vue&type=template&id=5dabd536&scoped=true&"
import script from "./ModalInfoVehicle.vue?vue&type=script&lang=js&"
export * from "./ModalInfoVehicle.vue?vue&type=script&lang=js&"
import style0 from "./ModalInfoVehicle.vue?vue&type=style&index=0&id=5dabd536&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dabd536",
  null
  
)

export default component.exports